module.exports = __webpack_public_path__ + "static/media/immunity.190a5af0.gif";